import { createContext, useContext, useEffect, useState, type PropsWithChildren } from 'react';
import { useSatellitePageView } from '../../../../hooks/useSatellitePageView';
import { useAnalytics } from '../../../../lib/analytics';
import { getAuthUrls } from './utils';

type AuthUrlContextType = {
  signInUrl: string | null;
  signUpUrl: string | null;
};

const AuthUrlContext = createContext<AuthUrlContextType | null>(null);

export function useRegisterAuthUrlPageViewAttributes() {}

export function AuthUrlProvider({ children }: PropsWithChildren) {
  const pageView = useSatellitePageView();
  const { analytics } = useAnalytics();
  const [signUpUrl, setSignUpUrl] = useState<string | null>(null);
  const [signInUrl, setSignInUrl] = useState<string | null>(null);

  useEffect(() => {
    async function updateAuthUrls() {
      const { newSignInUrl, newSignUpUrl } = await getAuthUrls(analytics, pageView ?? undefined);
      setSignInUrl(newSignInUrl);
      setSignUpUrl(newSignUpUrl);
    }
    void updateAuthUrls();
  }, [pageView, analytics]);

  return (
    <AuthUrlContext.Provider value={{ signInUrl, signUpUrl }}>{children}</AuthUrlContext.Provider>
  );
}

export function useAuthUrlsContext() {
  const authUrlsContext = useContext(AuthUrlContext);
  if (authUrlsContext === null) {
    throw new Error('useAuthUrlsContext must be used within an AuthUrlProvider');
  }
  return authUrlsContext;
}
